import React, { Component } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';


export class ContextMenu extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        if (this.props.menuItems) {
            var items = this.props.menuItems.map((item, i) => {
                return (
                    <MenuItem key={i} onClick={item.callBack}>{item.label}</MenuItem>
                )
            });
        }

        return (
            <Menu
                id={this.props.id}
                open={this.props.show}
                onClose={this.props.onClose}
                anchorReference="anchorPosition"
                PaperProps={{
                    elevation: 2,
                    sx: {
                        backgroundColor: (theme) => this.props.dark ? theme.palette.background.paper : theme.palette.background.paper,
                        color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.text.primary
                    }
                }}
                anchorPosition={
                    this.props.contextMenu !== null
                        ? { top: this.props.contextMenu.mouseY, left: this.props.contextMenu.mouseX }
                        : undefined
                }
                MenuListProps={{ sx: { backgroundColor: (theme) => this.props.dark ? theme.palette.background.paper : theme.palette.background.paper, color: (theme) => theme.palette.text.secondary } }}
            >
            {items}
            </Menu>

        );
    }
}
